import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';

const RestDashNfsePost = (config) => {

  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp      = storage[0];
  const uid      = storage[3];
  const tipoUser = storage[7];
  const token    = storage[14];

  const handleDashError = (xhr, reject) => {
    console.error('Erro AJAX:', {xhr});
    if (xhr?.message === 'erro_auth') {
      showDuplicateLoginAlert();
    }

    reject([400, {message: 'erro'}]);
  };

  const ajaxPostEvent = (ll, dd, pp, tk) => {
    return new Promise(function (resolve, reject) {
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'POST',
          dataType: 'text',
          headers: {
            'Authorization': 'Bearer ' + tk,
          },
          data: {
            ll: base64_encode(ll),
            dd: base64_encode(JSON.stringify(dd)),
            pp: base64_encode(pp),
            tk,
          },
          success: function (data) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            handleDashError(xhr, reject);
          },
        });
      } catch (err) {
        reject([500, {message: err + ' Server Error'}]);
      }
    });
  };

  switch (caminho) {
    case 'nfseKpi':
      return ajaxPostEvent('nfseKpi', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseEvolucaoMensal':
      return ajaxPostEvent('nfseEvolucaoMensal', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseImpostos':
      return ajaxPostEvent('nfseImpostos', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseParticipacao':
      return ajaxPostEvent('nfseParticipacao', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseRiscos':
      return ajaxPostEvent('nfseRiscos', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseFlags':
      return ajaxPostEvent('nfseFlags', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    case 'nfseRanking':
      return ajaxPostEvent('nfseRanking', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify([...Arr_.dataPost, tipoUser]))], 'dashboardNfse', token);
    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

export {RestDashNfsePost};
